import React, { ReactElement } from "react"
import {
	Box,
	FormControlLabel,
	Checkbox,
	TextField,
	Tooltip,
	Divider,
} from "@material-ui/core"
import InfoIcon from "@material-ui/icons/Info"
import { useCustomTitleStyles } from "./__config/styles"

/**
 * Prop definition for the custom title form
 *
 * @interface UseCustomTitleProps
 */
interface UseCustomTitleProps {
	useCustom: boolean
	onChange: InputChange
	changeCheck: InputChange
	title: string
}

const tipContent = "Možete dodati vlastiti naslov......."

/**
 * Component that allows a user to opt into a custom canvas title
 * and provides them with a input field
 *
 * @export
 * @param {UseCustomTitleProps} {
 * 	useCustom,
 * 	onChange,
 * 	changeCheck,
 * 	title,
 * }
 * @returns {ReactElement}
 */
export default function UseCustomTitle({
	useCustom,
	onChange,
	changeCheck,
	title,
}: UseCustomTitleProps): ReactElement {
	const cls = useCustomTitleStyles()

	return (
		<Box>
			{useCustom && (
				<TextField
					id="canvasTitle"
					name="canvasTitle"
					label="Custom naslov Cash Flow-a"
					variant="outlined"
					value={title}
					onChange={onChange}
					fullWidth
					className={cls.textField}
					InputLabelProps={{
						htmlFor: "canvasTitle",
					}}
				/>
			)}
			<Box className={cls.checkboxRoot}>
				<FormControlLabel
					control={
						<Checkbox
							name="use-custom-title"
							onChange={changeCheck}
							checked={useCustom}
						/>
					}
					label="Koristi custom naslov"
				/>
				<Tooltip title={tipContent}>
					<InfoIcon color="primary" />
				</Tooltip>
			</Box>
			<Divider className={cls.divider} />
		</Box>
	)
}
